module.exports = __webpack_public_path__ + "img/clam.983e0689.png";